import { List, Map } from 'immutable'
import { FirebaseList } from '../firebase'
import * as confirmedGroupActions from './actions'
import { ConfirmedGroup } from './confirmed-group'


class ConfirmedGroupList extends FirebaseList {
  unwrapSnapshot(snapshot) {
    let attrs = snapshot.val()
    let newGroup = {
      memberIds: {...attrs},
      numAccepts: attrs.numAccepts,
      numRejects: attrs.numRejects,
      isConfirmed: attrs.isConfirmed,
      creatorEmail: attrs.creatorEmail,
      leaderEmail: attrs.leaderEmail,
      key: snapshot.key,
      groupSize: attrs.groupSize,
      isDisbanded: attrs.isDisbanded,
      groupLotteryNumber: attrs.groupLotteryNumber,
      hasSubmittedPreferences: attrs.hasSubmittedPreferences,
      multiYearGroup: attrs.multiYearGroup
    }
    delete newGroup.memberIds.numAccepts
    delete newGroup.memberIds.numRejects
    delete newGroup.memberIds.isConfirmed
    delete newGroup.memberIds.creatorEmail
    delete newGroup.memberIds.leaderEmail
    delete newGroup.memberIds.groupSize
    delete newGroup.memberIds.memberRecords
    delete newGroup.memberIds.groupLotteryNumber
    delete newGroup.memberIds.preferences
    delete newGroup.memberIds.hasSubmittedPreferences
    delete newGroup.memberIds.multiYearGroup
    delete newGroup.memberIds.isDisbanded

    newGroup.memberIds = new List(Object.keys(newGroup.memberIds))
    newGroup.memberRecords = new Map(attrs.memberRecords)
    newGroup.preferences = new List(attrs.preferences)

    return new this._modelClass(newGroup)
  }
}

export const confirmedGroupList = new ConfirmedGroupList({
  onAdd: confirmedGroupActions.createConfirmedGroupSuccess,
  onChange: confirmedGroupActions.updateConfirmedGroupSuccess,
  onLoad: confirmedGroupActions.loadConfirmedGroupSuccess,
  onRemove: confirmedGroupActions.deleteConfirmedGroupSuccess
}, ConfirmedGroup)


// WEBPACK FOOTER //
// ./src/core/confirmed-group/confirmed-group-list.js